import { cs, de, enUS as en, pl, sk, uk, type Locale } from 'date-fns/locale' // Import jazyku

export const Language = {
    CZ: 1,
    SK: 2,
    EN: 3,
    PL: 4,
    DE: 5,
    UA: 6
}

export type Language = typeof Language[keyof typeof Language]

export type LanguageType = 'Cz' | 'Sk' | 'En' | 'Pl' | 'De' | 'Ua'

export type LanguageOption = {
    code: LanguageType
    label: string
    id: Language
    locale: Locale
}

export const languageOptions: LanguageOption[] = [
    { code: 'Cz', label: 'Čeština', id: Language.CZ, locale: cs },
    { code: 'Sk', label: 'Slovenčina', id: Language.SK, locale: sk },
    { code: 'En', label: 'English', id: Language.EN, locale: en },
    { code: 'Pl', label: 'Polski', id: Language.PL, locale: pl },
    { code: 'De', label: 'Deutsch', id: Language.DE, locale: de },
    { code: 'Ua', label: 'Українська', id: Language.UA, locale: uk },
]